module.exports = __webpack_public_path__ + "static/media/logo.585fcd31.svg";